/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Position } from './position';
import { Size } from './size';
import { WidgetTransfer } from './widgetTransfer';

export interface WindowTransfer {
    name?: string;
    positionDto?: Position;
    sizeDto?: Size;
    selected?: boolean;
    locked?: boolean;
    widgetToolbarState?: WindowTransfer.WidgetToolbarStateEnum;
    widgets?: Array<WidgetTransfer>;
}
export namespace WindowTransfer {
    export const WidgetToolbarStateEnum = {
        Default: 'DEFAULT',
        Expanded: 'EXPANDED',
        Collapsed: 'COLLAPSED'
    } as const;
    export type WidgetToolbarStateEnum = (typeof WidgetToolbarStateEnum)[keyof typeof WidgetToolbarStateEnum];
}
